import MoneroCheck from "./MoneroCheck";
/**
 * Results from checking a reserve proof.
 */
export default class MoneroCheckReserve extends MoneroCheck {
    constructor(check) {
        super(check);
        if (this.totalAmount !== undefined && typeof this.totalAmount !== "bigint")
            this.totalAmount = BigInt(this.totalAmount);
        if (this.unconfirmedSpentAmount !== undefined && typeof this.unconfirmedSpentAmount !== "bigint")
            this.unconfirmedSpentAmount = BigInt(this.unconfirmedSpentAmount);
    }
    toJson() {
        let json = Object.assign({}, this);
        if (this.getTotalAmount() !== undefined)
            json.totalAmount = this.getTotalAmount().toString();
        if (this.getUnconfirmedSpentAmount() !== undefined)
            json.unconfirmedSpentAmount = this.getUnconfirmedSpentAmount().toString();
        return json;
    }
    getTotalAmount() {
        return this.totalAmount;
    }
    setTotalAmount(totalAmount) {
        this.totalAmount = totalAmount;
        return this;
    }
    getUnconfirmedSpentAmount() {
        return this.unconfirmedSpentAmount;
    }
    setUnconfirmedSpentAmount(unconfirmedSpentAmount) {
        this.unconfirmedSpentAmount = unconfirmedSpentAmount;
        return this;
    }
}
